import { useSyncExternalStore } from "react";

/**
 * Suscripción a `window.matchMedia` (ej. breakpoints).
 * SSR: devuelve `false` hasta hidratar en el cliente.
 */
export function useMatchMedia(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mq = window.matchMedia(query);
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
